var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 54,
    viewBox: "0 0 46 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6082 16.6151V42.8322H33.5855V30.7724C33.5855 25.6418 33.6237 20.7352 33.7349 18.1118C33.7349 18.1118 31.3952 21.9631 28.6657 26.6755C26.9831 29.581 25.279 32.6026 23.7558 35.8183H22.571C21.3863 33.2796 19.5843 30.0638 17.8304 27.014C15.1174 22.2916 12.6483 18.0753 12.6483 18.0753C12.8342 21.072 12.9105 27.1766 12.9105 31.6701V41.3389H23.779L23.4836 42.819H12.9105V42.8322H10.8878V16.6151H13.9227C15.4168 19.9036 17.1177 23.0942 19.0151 26.1678C19.9692 27.7342 20.686 29.05 21.3863 30.2314C22.1413 31.5041 22.8548 32.6142 23.248 33.4488C23.248 33.4488 25.1463 30.2049 27.6502 25.8293C29.2265 23.0748 31.0368 19.9039 32.6115 16.6151H35.6082Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3278 5V2.59199L42.1665 3.65366L23.559 12.7938L4.80425 3.97445L2.67466 2.97302L2.66594 5.32631L2.50001 50.1277L2.49443 51.6332H4H42.8278H44.3278V50.1332V5Z",
    stroke: "#33AA72",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandlogo);
export default __webpack_public_path__ + "static/media/brandlogo.40364589295e4b3d615b8f7345be9e90.svg";
export { ForwardRef as ReactComponent };